import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import type { Refund, RefundPaddingParams, RefundForm, RefundAmountParams, RefundApproveForm } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";

export class RefundService extends BaseService<Refund, Refund, RefundPaddingParams, RefundForm> {
    /**
     * 创建
     */
    @confirmable("是否提交")
    public async add(form: RefundForm) {
        const { data } = await this.service.post(this.path, form);
        return data;
    }

    /**
     * 修改
     */
    @confirmable("是否提交")
    public async edit(id: string, form: RefundForm) {
        const { data } = await this.service.put(`${this.path}/${id}`, form);
        return data;
    }

    /**
     * 取消
     */
    @confirmable("是否取消")
    public async cancel(id: string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    /**金额查询 */
    async getAmount(params: RefundAmountParams): Promise<{ refundTotalAmount: number; refundedAmount: number }> {
        const { data } = await this.service.get(`${this.path}/amount`, {
            params
        });
        return data;
    }

    /**
     * 审核
     */
    async approve(id: string, form: RefundApproveForm) {
        const { data } = await this.service.put(`${this.path}/approve/${id}`, form);
        return data;
    }

    /**
     * 处理
     */
    async handle(id: string, form: RefundApproveForm) {
        const { data } = await this.service.put(`${this.path}/handle/${id}`, form);
        return data;
    }

    /**
     * 在对话框中新增
     * */
    async createInDialog(form: RefundForm) {
        const { data } = await this.service.post(`${this.path}`, form);
        return data;
    }

    /**
     * 在对话框中新增
     * */
    async updateInDialog(id: string, form: RefundForm) {
        const { data } = await this.service.put(`${this.path}/${id}`, form);
        return data;
    }
}

export const refundService = new RefundService("/admin/refund", request.service);
